import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import withCollectionStepper from 'Components/ComponentLibrary/HigherOrderComponents/withCollectionStepper';
import fr from 'facet-rest';
import WhatIfWizardCollectionStepperTemplateContent from './Content';

const styles = () => ({
  root: {},
});

const WhatIfWizardCollectionStepperTemplate = ({
  className,
  classes,
  layout,
  metaOverrideSet,
  collection,
}) => {
  const ContentWithCollectionStepper = withCollectionStepper(collection, WhatIfWizardCollectionStepperTemplateContent);

  return (
    <ContentWithCollectionStepper
      className={classNames(className, classes.root)}
      layout={layout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

WhatIfWizardCollectionStepperTemplate.defaultProps = {
  className: '',
  metaOverrideSet: undefined,
};

WhatIfWizardCollectionStepperTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  layout: PropTypes.object.isRequired,
  metaOverrideSet: PropTypes.object,
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export default withStyles(styles)(WhatIfWizardCollectionStepperTemplate);
